import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const OPTION = 'option'
export const FREQUENCY = 'frequency'
export const COUNT = 'count'
export const TOTAL = 'total'

export default {
  [PORTUGUESE]: {
    [OPTION]: 'Opção',
    [FREQUENCY]: 'Frequência',
    [COUNT]: 'Contagem',
    [TOTAL]: 'Total',
  },

  [ENGLISH]: {
    [OPTION]: 'Option',
    [FREQUENCY]: 'Frequency',
    [COUNT]: 'Count',
    [TOTAL]: 'Total',
  },

  [SPANISH]: {
    [OPTION]: 'Opción',
    [FREQUENCY]: 'Frecuencia',
    [COUNT]: 'Contar',
    [TOTAL]: 'Total',
  },
}
